export var QualityLimitationReason;
(function (QualityLimitationReason) {
    QualityLimitationReason["CPU"] = "cpu";
    QualityLimitationReason["Bandwidth"] = "bandwidth";
})(QualityLimitationReason || (QualityLimitationReason = {}));
export var GVCInternalRTCStatsEvent;
(function (GVCInternalRTCStatsEvent) {
    GVCInternalRTCStatsEvent["QualityLimitation"] = "qualityLimitation";
    GVCInternalRTCStatsEvent["BandwidthUtilization"] = "bandwidthUtilization";
})(GVCInternalRTCStatsEvent || (GVCInternalRTCStatsEvent = {}));
//# sourceMappingURL=RTCStatsEvent.js.map